import axios, { AxiosError } from 'axios';

import { AUTH_TOKEN_KEY } from '@/constant/localStorage';
import storage from '@/utils/storage';

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

axiosInstance.interceptors.request.use(config => {
  const token = storage.getItem(AUTH_TOKEN_KEY);

  const isPublic = /\/auth\/(login|signup)/.test(config.url || '');

  if (token && !isPublic) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  response => {
    console.log('✅ API Response:', {
      url: response.config.url,
      status: response.status,
      data: response.data,
    });
    return response;
  },
  (error: AxiosError) => {
    console.error('❌ API Error:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.response?.data || error.message,
    });

    return Promise.reject(error);
  }
);

const handleError = (error: unknown, context: string): never => {
  console.error(`${context} failed:`, error);

  if (error instanceof AxiosError) {
    const message = error.response?.data?.message || 'Request failed';
    throw new Error(message);
  }

  if (error instanceof Error) {
    throw error;
  }

  throw new Error('Unexpected error occurred');
};

export default axiosInstance;
export { handleError };
